import { Article, IGetArticleDto } from "./Article"
import { Guid, ITranslations } from "@/types"

export interface IGetArticleMachineBaseDto extends IGetArticleDto {
    productLineId: string
    productFamilyId: string
    productModelId: Guid
    productLineDescription?: string
    productFamilyDescription?: string
    productModelDescription?: string
}

export class ArticleMachineBase extends Article {
    productLineId: string
    productFamilyId: string
    productModelId: Guid
    productModelDescription?: string
    productLineDescription?: string
    productFamilyDescription?: string
    features?: ITranslations

    constructor(dto: IGetArticleMachineBaseDto) {
        super(dto)

        this.productLineId = dto.productLineId
        this.productFamilyId = dto.productFamilyId
        this.productModelId = dto.productModelId
        this.productModelDescription = dto.productModelDescription
        this.productLineDescription = dto.productLineDescription
        this.productFamilyDescription = dto.productFamilyDescription
    }

    getHierarchyDescription(): string {
        return [this.productLineDescription, this.productFamilyDescription, this.productModelDescription]
            .filter(i => !!i)
            .join(" / ")
    }

    create() {
        throw new Error("Use static create method instead")
    }
}
